/**
 * Configure console log levels based on environment variable
 * Call this early in your application to set up proper logging levels
 */
export function configureLogLevel(logLevel?: string) {
    const LOG_LEVEL = logLevel || process.env.LOG_LEVEL || "info";
    const logLevels = { error: 0,
warn: 1,
info: 2,
debug: 3 };
    const currentLevel = logLevels[LOG_LEVEL as keyof typeof logLevels] ?? 2;

    if (currentLevel < 3) console.debug = () => { };
    if (currentLevel < 2) console.log = () => { };
    if (currentLevel < 1) console.warn = () => { };
    if (currentLevel < 0) console.error = () => { };
}

/** Module-scoped backup of the original console methods. */
let originalConsole: Pick<Console, "log" | "warn" | "error" | "debug"> | undefined;

/**
 * Reset console methods to their original state
 */
export function resetConsole() {
    // Store original methods if not already stored
    if (!originalConsole) {
        originalConsole = {
            log: console.log,
            warn: console.warn,
            error: console.error,
            debug: console.debug
        };
    }

    console.log = originalConsole.log;
    console.warn = originalConsole.warn;
    console.error = originalConsole.error;
    console.debug = originalConsole.debug;
}
